import {
  LayoutDashboard, Tag, CreditCard, AlertTriangle,
  Scale, Clock, BarChart3, UserCog, Settings, Users,
  Megaphone, CalendarDays, FileText, Headphones, Banknote,
  type LucideIcon,
} from 'lucide-react'
import type { UserRole } from '@/types/core'

export interface NavModule {
  id:           string
  label:        string
  icon:         LucideIcon
  path:         string
  allowedRoles: UserRole[]
}
export interface NavSection {
  id: string; label: string; modules: NavModule[]
}

export const NAV_SECTIONS: NavSection[] = [
  {
    id: 'core', label: 'Principal',
    modules: [
      { id:'dashboard', label:'Dashboard', icon:LayoutDashboard, path:'/',             allowedRoles:[] },
    ],
  },
  {
    id: 'operaciones', label: 'Operaciones',
    modules: [
      { id:'marcados',       label:'Marcado',        icon:Tag,           path:'/marcados',      allowedRoles:[] },
      { id:'cobros',         label:'Cobros',          icon:CreditCard,    path:'/cobros',        allowedRoles:[] },
      { id:'pagos',          label:'Pagos',           icon:Banknote,      path:'/pagos',         allowedRoles:[] },
      { id:'impugnaciones',  label:'Impugnaciones',   icon:AlertTriangle, path:'/impugnaciones', allowedRoles:[] },
      { id:'embargo',        label:'Para Embargo',    icon:Scale,         path:'/embargo',       allowedRoles:[] },
      { id:'habeas',         label:'Habeas Data',     icon:Clock,         path:'/habeas',        allowedRoles:[] },
    ],
  },
  {
    id: 'consulta', label: 'Consulta',
    modules: [
      { id:'clientes', label:'Clientes', icon:Users, path:'/clientes', allowedRoles:[] },
    ],
  },
  {
    id: 'legal', label: 'Gestión Legal',
    modules: [
      { id:'legal-embargos',       label:'Embargos',       icon:Scale,    path:'/legal/embargos',       allowedRoles:['admin','agente_legal'] },
      { id:'legal-levantamientos', label:'Levantamientos', icon:FileText, path:'/legal/levantamientos', allowedRoles:['admin','agente_legal'] },
    ],
  },
  {
    id: 'gestion', label: 'Gestión',
    modules: [
      { id:'agenda',        label:'Agenda',        icon:CalendarDays, path:'/agenda',        allowedRoles:[] },
      { id:'campanas',      label:'Campañas',      icon:Megaphone,    path:'/campanas',      allowedRoles:['admin','supervisor'] },
      { id:'call-center',   label:'Call Center',   icon:Headphones,   path:'/call-center',   allowedRoles:['admin','supervisor'] },
      { id:'marcador',      label:'Listas de Marcado', icon:Tag,      path:'/call-center/marcador', allowedRoles:['admin','supervisor'] },
      { id:'reportes',      label:'Reportes',      icon:BarChart3,    path:'/reportes',      allowedRoles:['admin','supervisor'] },
      { id:'usuarios',      label:'Usuarios',      icon:UserCog,      path:'/usuarios',      allowedRoles:['admin'] },
      { id:'configuracion', label:'Configuración', icon:Settings,     path:'/configuracion', allowedRoles:['admin'] },
    ],
  },
]

export function getVisibleSections(role: UserRole): NavSection[] {
  return NAV_SECTIONS
    .map(section => ({
      ...section,
      modules: section.modules.filter(m =>
        m.allowedRoles.length === 0 || m.allowedRoles.includes(role)
      ),
    }))
    .filter(s => s.modules.length > 0)
}
